module.exports = __webpack_public_path__ + "img/powered-by.1c3e27c0.svg";